import Card from 'components/card';
import { BsCalendar3 } from 'react-icons/bs';
import InputField from 'components/fields/InputField';
import { QUICK_RANGES, resolveQuickRange } from './helpers';

/**
 * Global period filter bar shared by every KPI card.
 *
 * Exposes quick-range shortcuts (7d / 30d / 90d / month / year) plus custom
 * date inputs. Lifts the selected `{ from, to }` up to the page so all cards
 * stay in sync.
 */
function KpiFilters(props: {
    from: string;
    to: string;
    quickRange: string;
    onQuickRange: (value: string) => void;
    onFromChange: (value: string) => void;
    onToChange: (value: string) => void;
    onRefresh?: () => void;
}) {
    const { from, to, quickRange, onQuickRange, onFromChange, onToChange, onRefresh } =
        props;

    return (
        <Card extra="mb-5 p-4 border">
            <div className="flex flex-col items-stretch gap-3 lg:flex-row lg:items-center">
                {/* Quick range shortcuts */}
                <div className="scrollbar-hide flex items-center gap-2 overflow-x-auto pb-2 lg:pb-0">
                    {QUICK_RANGES.map((range) => (
                        <button
                            key={range.value}
                            onClick={() => {
                                const { from: f, to: t } = resolveQuickRange(range.value);
                                onQuickRange(range.value);
                                onFromChange(f);
                                onToChange(t);
                            }}
                            className={`flex-shrink-0 rounded-lg px-3 py-2 text-sm font-medium transition-all ${
                                quickRange === range.value
                                    ? 'bg-toola-500 text-white shadow-md'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                            {range.label}
                        </button>
                    ))}
                </div>

                <div className="hidden h-8 w-px bg-gray-200 lg:block"></div>

                {/* Custom date range */}
                <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white p-2 lg:flex-1 lg:max-w-md">
                    <BsCalendar3 className="flex-shrink-0 text-gray-400" />
                    <InputField
                        placeholder="Début"
                        id="bi-startDate"
                        type="date"
                        value={from}
                        onChange={(e: any) => {
                            onQuickRange('custom');
                            onFromChange(e.target.value);
                        }}
                        inputSmall={true}
                        extra="!mb-0 !border-0 !w-auto"
                    />
                    <span className="flex-shrink-0 text-gray-400">→</span>
                    <InputField
                        placeholder="Fin"
                        id="bi-endDate"
                        type="date"
                        value={to}
                        onChange={(e: any) => {
                            onQuickRange('custom');
                            onToChange(e.target.value);
                        }}
                        inputSmall={true}
                        extra="!mb-0 !border-0 !w-auto"
                    />
                </div>

                {onRefresh && (
                    <button
                        onClick={onRefresh}
                        className="flex-shrink-0 rounded-lg bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 transition-all hover:bg-gray-200"
                    >
                        Rafraîchir
                    </button>
                )}
            </div>
        </Card>
    );
}

export default KpiFilters;
